import {
    IQuestionnaireSection, IQuestionnaireSubSection, IConditionalOptions,
    EnumSectionType, EnumCAMTherapieName, GenereateCAMRes, GenereateCAMEndRes,
    EnumQuestionType, EnumFreeTextType, EnumInputSize, EmptyAnswer, ISymptomeName,
    EnumMedikamentName, GenereateMedikamentRes, GenereateNichtRes, emailPattern
} from './questionnaire.model';

export const categoryOptions: string[] = [
    "Cannabisextrakt",
    "Dronabinol",
    "Cannabisblüten",
    "Sativex",
    "Canemes",
    "Kapseln",
    "Andere"
]

export const freeTextInput = "Andere, Freitext";
export const KeineNebenwirkungen = "Keine Nebenwirkungen";

export const CamTherapieSecondSubSection: IQuestionnaireSubSection = {
    number: 2,
    title: "Angaben zu Cannabisarzneimitteln, die zum Betrachtungszeitpunkt der Kasuistik im Rahmen der Indikation eingesetzt werden",
    description: `Bei der Dosierung (Tagesbedarf) kann entweder der gesamte Tagesbedarf angegeben werden oder nach dem Schema "morgens - mittags - abends" (bspw. bei Applikation in Millilitern: 0,3 - 0,3 - 0,5.`,
    questions: [],
    sectionType: EnumSectionType.CAMTHERAPIE,
    therapieObj: {
        therapieName: EnumCAMTherapieName.CAMTherapie,
        addMore: "weitere CAM",
        required: true,
        responseData: [GenereateCAMRes()],
        category: {
            label: "Form des Cannabisarzneimittels",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: categoryOptions
        },
        product: {
            label: "Genaue Bezeichnung",
            inputType: EnumQuestionType.INPUT,
            required: false,
            hidden: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        startDate: {
            label: "Start der Therapie",
            inputType: EnumQuestionType.MONTH,
            required: true
        },
        phaseDuration: {
            label: "Dauer der Titrationsphase in Wochen",
            inputType: EnumQuestionType.INPUT,
            required: true
        },
        applicationUnit: {
            label: "Applikationsform/Einheit",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        dailyDosage: {
            label: "Dosierung (Tagesbedarf)",
            inputType: EnumQuestionType.INPUT,
            required: true
        },
        remarks: {
            label: "Anmerkungen",
            inputType: EnumQuestionType.INPUT,
            placeholder: "Besonderheiten, bspw. in Bezug auf die Dosierung oder Form des Cannabisarzneimittels."
        }
    }
}

export const CamTherapieFourthSubSection: IQuestionnaireSubSection = {
    number: 4,
    title: "Bitte benennen Sie die Cannabisarzneimittel, die abgesetzt wurden.",
    questions: [],
    sectionType: EnumSectionType.CAMTHERAPIE,
    therapieObj: {
        therapieName: EnumCAMTherapieName.CAMTherapieEnd,
        addMore: "weitere CAM",
        required: true,
        responseData: [GenereateCAMEndRes()],
        category: {
            label: "Form des Cannabisarzneimittels",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: categoryOptions
        },
        product: {
            label: "Genaue Bezeichnung",
            inputType: EnumQuestionType.INPUT,
            required: false,
            hidden: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        startDate: {
            label: "Start der Therapie",
            inputType: EnumQuestionType.MONTH,
            required: true
        },
        endDate: {
            label: "Ende der Therapie",
            inputType: EnumQuestionType.MONTH,
            required: true
        },
        applicationUnit: {
            label: "Applikationsform/Einheit",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: [],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        },
        dailyDosage: {
            label: "Dosierung Therapieende (Tagesbedarf)",
            inputType: EnumQuestionType.INPUT,
            required: true
        },
        remarks: {
            label: "Begründung",
            inputType: EnumQuestionType.DROPDOWN,
            required: true,
            options: [
                "Nicht tolerierbare Nebenwirkungen",
                "Keine ausreichende Symptomlinderung nach Titrierungsphase",
                "Therapiekosten wurden nicht von der Krankenkasse übernommen",
                "CAM nicht verfügbar",
                "Wechsel zu einem anderen CAM",
                "Andere Begründung (Freitext)"
            ],
            freeTextInput: {
                inputType: EnumFreeTextType.INPUT
            }
        }
    }
}

export const IndikationOptions: IConditionalOptions[] = [
    {
        label: "Schmerz",
        options: [
            "Anhaltende somatoforme Schmerzstörung (F45.40)",
            "Chronisches Schmerzsyndrom (F45.41)",
            "Cluster-Kopfschmerz (G44.0)",
            "Endometriose (N94/N80)",
            "Fibromyalgie (M79.7)",
            "Gelenkschmerzen (M25)",
            "Maligne Erkrankung mit Tumorschmerz (R52.1)",
            "Migräne (G43)",
            "Muskelschmerzen (M79.1)",
            "Rheumaschmerzen (M79.0)",
            "Rückenschmerzen (M54)",
            "Schmerzen am Bewegungsapparat (M25)",
            "Spannungskopfschmerz (G44.2)",
            "Tumorschmerz (R52.1)",
            freeTextInput
        ]
    },
    {
        label: "Spastik",
        options: [
            "Krämpfe und Spasmen der Muskulatur (R25.2)",
            "Morbus Parkinson (G20)",
            "Multiple Sklerose (G35)",
            "Spastische Para-/Tetraparese und Para-/Tetraplegie (G82)",
            "Spinale Spastik der quergestreiften Muskulatur (G95.83)",
            freeTextInput
        ]
    },
    {
        label: "Neurologische Erkrankung",
        options: [
            "CFS (R53/G93.3)",
            "Cluster-Kopfschmerz (G44.0)",
            "Epilepsie (G40)",
            "Migräne (G43)",
            "Morbus Parkinson (G20)",
            "Multiple Sklerose (G35)",
            "Neuropathische Schmerzen (G56-63)",
            "Restless Legs Syndrom (G25.81)",
            "Schlafstörung (G47)",
            "Spannungskopfschmerz (G44.2)",
            "Spastische Para-/Tetraparese und Para-/Tetraplegie (G82)",
            "Spinale Spastik der quergestreiften Muskulatur (G95.83)",
            freeTextInput
        ]
    },
    {
        label: "Psychiatrische Erkrankung",
        options: [
            "ADHS (F90)",
            "Angststörung (F41)",
            "Anhaltende somatoforme Schmerzstörung  (F45.40)",
            "Chronisches Schmerzsyndrom (F45.41)",
            "Depression (F32)",
            "PTSD (F43.1)",
            "Tourette-Syndrom (F95)",
            freeTextInput
        ]
    },
    {
        label: "Krebserkrankung",
        options: [
            "Angststörung unter maligner Erkrankung (F41)",
            "Appetitlosigkeit bei maligner Erkrankung (R63)",
            "Depression bei maligner Erkrankung (F32)",
            "Kachexie bei maligner Erkrankung (R64)",
            "Maligne Erkrankung mit Tumorschmerz (R52.1)",
            "Schlafstörung bei maligner Erkrankung (G47)",
            "Tumorschmerz (R52.1)",
            "Übelkeit und Erbrechen unter Chemotherapie (Y57.9!)",
            "Übelkeit und/oder Erbrechen (R11)",
            freeTextInput
        ]
    },
    {
        label: "Gastrointestinale Erkrankung",
        options: [
            "Colitis ulcerosa (K51)",
            "Kachexie (R64)",
            "Morbus Crohn (K50)",
            "Reizdarm (K58)",
            "Übelkeit und/oder Erbrechen (R11)",
            freeTextInput
        ]
    },
    {
        label: "Andere",
        options: [
            "CFS (R53/G93.3)",
            "Endometriose (N94/N80)",
            "Kachexie (R64)",
            "Schlafstörung (G47)",
            "Übelkeit und/oder Erbrechen (R11)",
            freeTextInput
        ]
    }
]

export const NebenwirkungenSecondSubSection: IQuestionnaireSubSection = {
    number: 2,
    title: "Auswirkung auf die Lebensqualität",
    description: `Bitte geben Sie das Ausmaß an, wie stark die von Ihnen angegebenen Nebenwirkungen jeweils die Lebensqualität negativ beeinflussen.<br/>
    (0 = <strong>keine negative Auswirkung</strong> auf die Lebensqualität - 10 = <strong>stärkste negative Auswirkung</strong> auf die Lebensqualität)`,
    sectionType: EnumSectionType.SYMPTOMES,
    symptomeObj: {
        dependedToThis: ISymptomeName.NebenwirkungenAuswahl,
        symptomes: []
    },
    questions: []
}

export const QuestionnaireJSON: IQuestionnaireSection[] = [
    {
        number: 1,
        stepper: 'Fachrichtung',
        title: 'Angaben zu Ihrer Person',
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Fachrichtung",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Allgemeinmedizin", "Anästhesiologie", "Gynäkologie", "Innere Medizin", "Neurologie", "Orthopädie und Unfallchirurgie", "Physikalische und Rehabilitative Medizin", "Psychiatrie und Psychotherapie", freeTextInput]
                    },
                    {
                        number: 2,
                        title: "Bundesland",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Baden-Württemberg", "Bayern", "Berlin", "Brandenburg", "Bremen", "Hamburg", "Hessen", "Mecklenburg-Vorpommern", "Niedersachsen", "Nordrhein-Westfalen", "Rheinland-Pfalz", "Saarland", "Sachsen", "Sachsen-Anhalt", "Schleswig-Holstein", "Thüringen", freeTextInput]
                    }
                ]
            }
        ]
    },
    {
        number: 2,
        stepper: "Angaben Patient:in",
        title: "Angaben zur/zum Patient:in",
        infoText: "*Freiwillige Angaben",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Wie ist der Behandlungsstatus? Der/die Patient:in ...",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["befindet sich aktuell bei Ihnen in Behandlung", "wurde in der Vergangenheit von Ihnen behandelt"]
                    },
                    {
                        number: 2,
                        title: "Zeitpunkt der Betrachtung der Kasuistik (Beobachtungszeitpunkt, z.B. Beendigung der Behandlung)",
                        placeholder: "Monat/Jahr",
                        inputType: EnumQuestionType.MONTH,
                        inputSize: EnumInputSize.MEDIUM,
                        hidden: true,
                        required: false,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "Geburtsjahr",
                        inputType: EnumQuestionType.INPUT,
                        questSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "Körpergewicht in Kilogramm*",
                        inputType: EnumQuestionType.INPUT,
                        questSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 5,
                        title: "Körpergröße in Zentimeter*",
                        inputType: EnumQuestionType.INPUT,
                        questSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 6,
                        title: "Geschlecht",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Männlich", "Weiblich", "Divers"],
                        divider: true
                    },
                    {
                        number: 7,
                        title: "Geht die Person einer beruflichen Tätigkeit nach?",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Ja", "Nein", "Unbekannt"]
                    },
                    {
                        number: 8,
                        title: "Welchen Beruf übt die Person aus?*",
                        inputType: EnumQuestionType.INPUT,
                        answer: EmptyAnswer(),
                        hidden: true,
                        divider: true
                    },
                    {
                        number: 9,
                        title: "Liegt eine krankheitsbedingte Berufsunfähigkeit vor?*",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        answer: EmptyAnswer(),
                        data: ["Ja", "Nein"],
                        hidden: true,
                        divider: true
                    },
                    {
                        number: 10,
                        title: "Wie ist die Patientin oder der Patient versichert?",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Gesetzlich versichert", "Privat versichert"]
                    },
                    {
                        number: 11,
                        title: "Werden die Kosten der Therapie mit Cannabisarzneimitteln durch die Versicherung getragen?",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Ja", "Nein", "Unbekannt"],
                        divider: true
                    },
                    {
                        number: 12,
                        title: "Warum werden die Kosten der Therapie nicht durch die Versicherung getragen?*",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        hidden: true,
                        answer: EmptyAnswer(),
                        data: ["Ablehnung eines Antrags", "Kein Antrag gestellt", "Ist in Bearbeitung", freeTextInput],
                        divider: true
                    },
                    {
                        number: 13,
                        title: "Wie wurde die Therapie mit Cannabisarzneimitteln initiiert?*",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        answer: EmptyAnswer(),
                        data: ["Ärztlich", "Durch Patient:in"]
                    },
                    {
                        number: 14,
                        title: "Bestanden Erfahrungen mit Cannabis vor der ärztlichen Verordnung?*",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.MEDIUM,
                        answer: EmptyAnswer(),
                        data: ["Ja", "Nein"]
                    },
                    {
                        number: 15,
                        title: "Besteht ein Substanzmissbrauch? (Mehrfachauswahl möglich)*",
                        inputType: EnumQuestionType.DROPDOWN,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: ["Keine Angabe", "Alkohol", "Benzodiazepine", "Cannabis", "Halluzinogene", "Nikotin", "Opioide", "Psychostimulanzien"]
                    }
                ]
            }
        ]
    },
    {
        number: 3,
        stepper: "Beschwerdebild",
        title: "Beschwerdebild",
        description: "Angaben zur Indikation für die Therapie mit Cannabisarzneimitteln",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Treffen Sie bitte eine Auswahl eines Beschwerdebilds zur Eingrenzung der Indikation für die Therapie.",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        answer: EmptyAnswer(),
                        data: ["Schmerz", "Spastik", "Neurologische Erkrankung", "Psychiatrische Erkrankung", "Krebserkrankung", "Gastrointestinale Erkrankung", "Andere"],
                        conditionalOptions: {
                            dependedKey: "Indikation"
                        }
                    },
                    {
                        number: 2,
                        title: "Bitte benennen Sie die Indikation der Therapie.",
                        description: "(Hier ist nur eine Einfachnennung möglich. Angaben zu weiteren, gleichzeitig bestehenden Erkrankungen werden weiter unten abgefragt)",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        answer: EmptyAnswer(),
                        data: [],
                        conditionalOptions: {
                            dependedKey: "Indikation",
                            options: IndikationOptions
                        }
                    },
                    {
                        number: 3,
                        title: "Seit wann besteht die Erkrankung der Indikation?",
                        inputType: EnumQuestionType.MONTH,
                        inputSize: EnumInputSize.SMALL,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "Aus welchem Grund werden oder wurden Cannabisarzneimittel als medikamentöse Therapie bei dieser Indikation eingesetzt? (Mehrfachnennung möglich)",
                        inputType: EnumQuestionType.DROPDOWN,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        required: true,
                        multiple: true,
                        answer: EmptyAnswer(),
                        data: [
                            "Cannabisarzneimittel sind Bestandteil der leitliniengerechten Therapie dieser Indikation",
                            "Die leitliniengerechte Therapie ist oder war ausgeschöpft (bspw. Höchstdosierung erreicht ohne ausreichende Therapieeffekte)",
                            "Die leitliniengerechte Therapie verursacht(e) nicht-tolerierbare Nebenwirkungen",
                            "Es bestehen oder bestanden Kontraindikationen gegen bestimmte Medikamente der leitliniengerechten Therapie",
                            "Cannabisarzneimittel ergänzen die leitliniengerechte Therapie bei der Behandlung von weiteren Symptomen",
                            freeTextInput
                        ]
                    },
                    {
                        number: 5,
                        title: 'Weitere Diagnosen:',
                        inputType: EnumQuestionType.ICD10SEARCH,
                        icdCode: {
                            popupTitle: "Weitere Diagnosen",
                            buttonText: "ICD10 Suche"
                        },
                        answer: EmptyAnswer()
                    },
                    {
                        number: 6,
                        title: "Kurzanamnese bezogen auf die Indikation für die Therapie mit Cannabisarzneimitteln",
                        placeholder: `Beispiel: "Spondylodese 11/2018 bei progredienter Instabilität L3/4, Gonarthose re> li, Adipositas(BMI 32), IDDM, chronifizierter Schmerz und insuffiziente Schmerztherapie unter Opioiden bei ausgeprägten Nebenwirkungen(Obstipation, Schwindel bei Sturzgefährdung)."`,
                        inputType: EnumQuestionType.TEXTAREA,
                        required: true,
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    },
    {
        number: 4,
        stepper: "Symptombehandlung",
        title: "Symptome",
        description: "Im Rahmen der Indikation, die Sie oben angegeben haben, werden i.d.R. ein oder mehrere Symptome mit Cannabisarzneimittel behandelt. Treffen Sie zunächst eine Auswahl der relevanten Symptome, die mit CAM behandelt werden. Im nächsten Schritt können Sie die Veränderung des jeweiligen Symptoms bewerten.",
        subSections: [
            {
                number: 1,
                title: "Symptom Auswahl",
                description: "Bitte wählen Sie entsprechende Symptome aus, die im Rahmen der Therapie mit CAM behandelt werden. Sie können per Freitext auch weitere, aus Ihrer Sicht relevante Symptome hinzufügen.",
                required: true,
                symptomeObj: {
                    dependedByThis: ISymptomeName.SymptomAuswahl
                },
                questions: [
                    {
                        number: 1,
                        title: "<strong>Schmerzhafte Symptome</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Chronifizierter Schmerz", "Neuropathischer Schmerz", "Muskuloskelettale Schmerzen", "Migräne"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "<strong>Psychische Symptome</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Stress und/oder Anspannung", "Schlafstörungen", "Ängstlichkeit", "Innere Unruhe", "Depressive Verstimmung", "Hyperaktivität"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "<strong>Körperliche Symptome</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Übelkeit/Erbrechen", "Krampfanfälle", "Spastik / Spastische Lähmung", "Appetitlosigkeit/Gewichtsabnahme", "Durchfall", "Chronische Entzündung"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        extraOption: {
                            buttonText: "weitere Symptome",
                            multiple: true
                        },
                        data: [],
                        answer: EmptyAnswer()
                    }
                ]
            },
            {
                number: 2,
                title: "Auswirkung der Symptome auf die Lebensqualität",
                description: `Bitte geben Sie das Ausmaß an, wie stark das Symptom die Lebensqualität negativ beeinflusst.<br/>
                    (0= <strong>keine negative</strong> Auswirkung auf die Lebensqualität - 10 = <strong>stärkste negative</strong> Auswirkung auf die Lebensqualität)`,
                sectionType: EnumSectionType.SYMPTOMES,
                symptomeObj: {
                    dependedToThis: ISymptomeName.SymptomAuswahl,
                    symptomes: []
                },
                questions: []
            }
        ]
    },
    {
        number: 5,
        stepper: "Medikamentöse Therapie",
        title: "Medikamentöse Therapien (außer Cannabisarzneimittel)",
        description: "Welche anderen Medikamente wurden für die o.g. Indikation zum Zeitpunkt des Beginns der CAM-Therapie eingesetzt?",
        subSections: [
            {
                number: 1,
                questions: [],
                sectionType: EnumSectionType.MEDIKAMENT,
                medikamentObj: {
                    medikamentName: EnumMedikamentName.MedikamentTherapie,
                    addMore: "weitere Medikamente",
                    required: true,
                    responseData: [GenereateMedikamentRes(), GenereateMedikamentRes(), GenereateMedikamentRes()],
                    medikament: {
                        title: "Therapie",
                        label: "Medikament",
                        inputType: EnumQuestionType.INPUT,
                        required: true
                    },
                    darreichungsform: {
                        label: "Darreichungsform",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: ["per os", "intravenös", "transdermal", "subcutan", "sublingual", "per inhalationem", freeTextInput],
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        }
                    },
                    vorTherapie: {
                        title: "Vor Beginn der Therapie mit CAM",
                        label: "Tagesbedarf",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: ["hoch", "mittel", "niedrig", "kam nicht zum Einsatz"]
                    },
                    unterTherapie: {
                        title: "Unter der Therapie mit CAM",
                        label: "Tagesbedarf",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: ["hoch", "mittel", "niedrig", "abgesetzt"]
                    }
                }
            }
        ]
    },
    {
        number: 6,
        stepper: "Nicht-Med.Therapie",
        title: "Nicht-medikamentöse Therapien",
        description: "Welche nicht-medikamentösen Therapien wurden für die o.g. Indikation zum Zeitpunkt des Beginns der CAM-Therapie eingesetzt?",
        subSections: [
            {
                number: 1,
                questions: [],
                sectionType: EnumSectionType.MEDIKAMENT,
                medikamentObj: {
                    medikamentName: EnumMedikamentName.NichtTherapie,
                    addMore: "weitere nicht-medikamentöse Therapien",
                    required: false,
                    responseData: [GenereateNichtRes(), GenereateNichtRes(), GenereateNichtRes()],
                    medikament: {
                        title: "Nicht-medikamentöse Therapie",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        freeTextInput: {
                            inputType: EnumFreeTextType.INPUT
                        },
                        options: [
                            "Akupunktur",
                            "Bewegung und Bewegungstherapie",
                            "Rehabilitationssport und Funktionstraining",
                            "Entspannungsverfahren (Progressive Muskelrelaxation)",
                            "Ergotherapie",
                            "Interferenzstromtherapie",
                            "Kinesio-Taping",
                            "Kurzwellendiathermie",
                            "Lasertherapie",
                            "Magnetfeldtherapie",
                            "Manuelle Therapie (Manipulation/Mobilisation)",
                            "Massage",
                            "Perkutane elektrische Nervenstimulation (PENS)",
                            "Rückenschule",
                            "Thermotherapie (Wärmetherapie/Kältetherapie)",
                            "Traktion mit Gerät",
                            "Transkutane elektrische Nervenstimulation (TENS)",
                            "Therapeutischer Ultraschall",
                            "Verhaltenstherapie",
                            freeTextInput
                        ]
                    },
                    vorTherapie: {
                        title: "Vor Beginn der Therapie mit CAM",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: [
                            "Therapie kam vor Beginn Therapie mit CAM nicht zum Einsatz",
                            "Regelmäßige Anwendung (erfolgreich)",
                            "Regelmäßige Anwendung (nicht erfolgreich)",
                            "Therapie wurde angewandt, jedoch abgebrochen (erfolglos)",
                            "Therapie erfolgreich abgeschlossen"
                        ]
                    },
                    unterTherapie: {
                        title: "Unter der Therapie mit CAM",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        options: [
                            "Regelmäßige Anwendung (erfolgreich)",
                            "Regelmäßige Anwendung (nicht erfolgreich)",
                            "Therapie konnte erfolgreich beendet werden",
                            "Therapie musste erfolglos beendet werden",
                            "Therapie konnte unter der Therapie mit CAM begonnen werden",
                            "Keine Anwendung unter Therapie mit CAM"

                        ]
                    }
                }
            }
        ]
    },
    {
        number: 7,
        stepper: "CAM Therapie",
        title: "",
        subSections: [
            {
                number: 1,
                title: "Therapie mit Cannabisarzneimitteln",
                description: "Werden CAM zum Betrachtungszeitpunkt der Kasuistik eingesetzt?",
                questions: [
                    {
                        number: 1,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer(),
                        data: ["Ja", "Nein"],
                        required: true
                    }
                ]
            },
            {
                number: 2,
                title: "Wurden Cannabisarzneimittel abgesetzt?",
                questions: [
                    {
                        number: 1,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        inputSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer(),
                        data: ["Ja", "Nein"],
                        required: true
                    }
                ]
            }
        ]
    },
    {
        number: 8,
        stepper: "Nebenwirkungen CAM Therapie",
        title: "Nebenwirkungen der Therapie mit Cannabisarzneimitteln",
        description: "Wählen Sie bitte hier die Nebenwirkungen aus, die unter der Therapie mit CAM aufgetreten sind.",
        subSections: [
            {
                number: 1,
                title: "Nebenwirkungen Auswahl",
                required: true,
                symptomeObj: {
                    dependedByThis: ISymptomeName.NebenwirkungenAuswahl
                },
                questions: [
                    {
                        number: 1,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: [KeineNebenwirkungen],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "<strong>Psychische Nebenwirkungen</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Schläfrigkeit/Müdigkeit", "Schwindel/Gleichgewichtsstörung", "Gedächtnisstörung", "Unerwünschte Euphorie", "Konzentrations-/Aufmerksamkeitsstörung", "Desorientierung", "Lethargie", "Depression", "Halluzinogene Sinnestäuschungen und/oder Wahnvorstellungen"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "<strong>Körperliche Nebenwirkungen</strong>",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        data: ["Mundtrockenheit", "Übelkeit und/oder Erbrechen", "Ungewollte Gewichtszunahme", "Gerötete Augen", "Appetitsteigerung", "Kardiovaskulâre Beschwerden (Palpitationen/Tachykardie/Hypotonie)", "Verschwommenes Sehen", "Gastrointestinale Beschwerden (Diarrhoe oder Konstipation)"],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 4,
                        title: "",
                        inputType: EnumQuestionType.OPTION,
                        multiple: true,
                        removeOptionalClass: true,
                        extraOption: {
                            buttonText: "weitere Nebenwirkungen",
                            multiple: true
                        },
                        data: [],
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    },
    {
        number: 9,
        stepper: "Zusammenfassung",
        title: "Zusammenfassung",
        description: "Veränderung der Lebensqualität und Fazit der Therapie mit medizinischem Cannabis",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Wie hat sich die Therapie mit Cannabisarzneimitteln aus Ihrer Sicht auf die Lebensqualität der Patientin oder des Patienten ausgewirkt?",
                        placeholder: "(-5 = stark negative Auswirkung - 0 = keine Auswirkung +5 = stark positive Auswirkung)",
                        inputType: EnumQuestionType.POSNEGSLIDER,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "Ihre Erfahrung mit der Behandlung:<br/> Im Vergleich zum Ausgangszustand der Patientin oder des Patienten hat sich sich der Zustand dieses Patienten",
                        inputType: EnumQuestionType.DROPDOWN,
                        required: true,
                        divider: true,
                        extraClass: {
                            question: 'mt-3'
                        },
                        data: [
                            "Stark verbessert",
                            "Verbessert",
                            "Gering verbessert",
                            "Keine Veränderung",
                            "Gering verschlechtert",
                            "Verschlechtert",
                            "Stark verschlechtert"
                        ],
                        answer: EmptyAnswer()
                    },
                    {
                        number: 3,
                        title: "Generelle Anmerkungen bezogen auf die Therapie mit Cannabisarzneimitteln",
                        placeholder: "Bitte ziehen Sie ein generelles Fazit über die Therapie mit CAM bei diesem Fall. Was ist besonders gut gelaufen oder bestanden Schwierigkeiten in Bezug auf die Auswahl des CAMs oder die Dosierung? Wie bewerten Sie die Therapie generell? Haben Sie Empfehlungen für Kolleg:innen? Vielen Dank!",
                        inputType: EnumQuestionType.TEXTAREA,
                        required: true,
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    },
    {
        number: 10,
        stepper: "Dateneingabe Beenden",
        title: "Dateneingabe Beenden",
        subSections: [
            {
                number: 1,
                questions: [
                    {
                        number: 1,
                        title: "Bitte geben Sie Ihre E-Mail an",
                        inputType: EnumQuestionType.INPUT,
                        pattern: emailPattern,
                        required: true,
                        answer: EmptyAnswer()
                    },
                    {
                        number: 2,
                        title: "Bitte wiederholen Sie Ihre E-Mail",
                        lastInfo: `
<p><strong>Warum fragen wir nach Ihrer Email?</strong></p>
<p>Unser wissenschaftliches Team wird den von Ihnen eingereichten Fall überprüfen und freigeben. Wir werden Sie anschließend per E-Mail benachrichtigen, sobald die Kausalität veröffentlicht wird. Falls wir Rückfragen haben, werden wir uns ebenfalls per E-Mail an Sie wenden. Wir sind bestrebt, die einzelnen Fälle so schnell wie möglich zu bearbeiten und zu veröffentlichen. Die Email wird bei der Veröffentlichung des Falls nicht präsentiert.</p>
<p>Die eingehenden Formulare werden von unserem wissenschaftlichen Team unter der Leitung von Prof. Dr. med. Thomas Herdegen und André Ihlenfeld geprüft. Wenn Sie weitere Fragen haben zur Nutzung der Daten, klicken Sie bitte die FAQ Sektion.</p>
`,
                        extraClass: {
                            question: 'dateneingabe-beenden'
                        },
                        inputType: EnumQuestionType.INPUT,
                        pattern: emailPattern,
                        required: true,
                        answer: EmptyAnswer(),
                        validateValueWith: {
                            sectionNumber: 10,
                            subSectionNumber: 1,
                            questionNumber: 1
                        }
                    },
                    {
                        number: 3,
                        title: "<strong>Wenn Sie einen persönlichen Code von einem PEP Partner erhalten haben, geben Sie diesen bitte hier an:</strong>",
                        inputType: EnumQuestionType.INPUT,
                        inputSize: EnumInputSize.SMALL,
                        answer: EmptyAnswer()
                    }
                ]
            }
        ]
    }
]
